/** 钱包类型 */
export enum WalletSymbolTypes {
  BYBITCLOUD = 'Bybit',
  BYBITEX = 'com.bybit',
  METAMASK = 'io.metamask',
  WALLETCONNECT = 'walletConnect',
}

/** 链类型 */
export enum WalletChainTypes {
  EVM = 1,
  SUI = 2,
  SOLANA = 3,
  BTC = 4,
  STACKS = 5,
  TON = 7,
  TRON = 8,
}

/** 链数据 */
export type Chain = {
  /** 链ID */
  chainId: string | number;
  /** 链Code */
  chainCode: string;
  /** 链名称 */
  chainName: string;
  /** 日间图标 */
  iconDayUrl: string;
  /** 夜间图标 */
  iconNightUrl: string;
  /** 基础币种 */
  baseTokenName: string;
  /** @deprecated 基础币种 */
  baseToken: string;
  /** 网络 */
  networkName: string;
  /** 排序  */
  order: number;
  /** 支持L1的Gas */
  isSupportL1Gas: number;
  /** 链类型 */
  chainType: WalletChainTypes;
  /** 区分EIP1559，暂时无用 */
  gasType: 1;
  /** txAddress */
  txAddress: string;
  /** 链是否开放 */
  tmpStatus: 'open' | 'close';
  /** 创建时间 */
  createAt: number;
  /** 最小交易金额 */
  minTransaction: string;
};

export enum WalletType {
  NOT = 0,
  /** 云钱包，托管钱包 */
  CLOUD = 1,
  /** mpc钱包 */
  MPC = 2,
  /** AA钱包 */
  AA = 3,
  /** 私钥钱包 */
  PRIVATE_KEY = 4,
  /** 助记词钱包 */
  MNEMONIC_PHRASE = 5,
  /** 观察者钱包 */
  FOLLOW_ADDRESS = 6,
  /** metamask钱包或其他三方钱包 */
  THIRD_PARTY = 7,
}

export interface WalletInfo {
  pubKey?: string;
  /** 标识（用于埋点上报） */
  symbol?: string;
  /** 地址 */
  address: string;
  /** 别名 */
  alias?: string;
  /** 链类型，（1:EVM;2:SUI） */
  chainType?: WalletChainTypes;
  /** 钱包类型，（0:云钱包;1:三方钱包） */
  type?: WalletType;
  /** 用户ID */
  userId?: number;
  /** 公钥 */
  custodyPubKey?: string;
  /** 链ID */
  chainId?: number;
  /** 钱包类型 */
  walletType?: WalletType;
}

export type WalletAddress = { walletAddress: string; chainId: number };

export type WalletInfoByApp = {
  name: string;
  type: keyof typeof WalletType;
  walletType: keyof typeof WalletType;
  id: string;
  address: string;
  supportChainList: {
    address: string;
    chainCode: string;
    chainId: number;
    coinType: number;
    custodyPubKey: string;
    derivationPath: string;
    publicKey: string;
  }[];
};
